import Link from 'next/link'
import { ContentfulNpStartupFloatingBanner } from '../../types'
import Slider, { Settings } from 'react-slick'
import { css } from '@emotion/react'
import { colors, font, mq } from 'plume-ui'
import { CrossIcon } from '../atoms/icons/CrossIcon'
import { useState } from 'react'

type FloatingBannerProps = {
  onClose: () => void
  floatingBanner: ContentfulNpStartupFloatingBanner[] | null
  trackingIdPrefix: string
}

export const ThumbnailFloatingBanner = (props: FloatingBannerProps) => {
  const bannerItems: ContentfulNpStartupFloatingBanner[] =
    props.floatingBanner !== null
      ? props.floatingBanner
      : [
          {
            articleBannerImageUrl:
              '/static/images/seminor/slide_desktop_01.png',
            articleUrl: 'https://newspicks.com/news/999999/',
            newsId: 999999,
          },
          {
            articleBannerImageUrl:
              '/static/images/seminor/slide_desktop_02.jpg',
            articleUrl: 'https://newspicks.com/news/888888/',
            newsId: 888888,
          },
        ]
  const generateTrackingId = (index: number) => {
    return `${props.trackingIdPrefix}-fb-image` + ('00' + (index + 1)).slice(-2)
  }

  const [href, setHref] = useState(bannerItems[0].articleUrl)
  const [id, setId] = useState(generateTrackingId(0))

  const onSlideChange = (currentSlide: number) => {
    setHref(bannerItems[currentSlide].articleUrl)
    setId(generateTrackingId(currentSlide))
  }

  const settings: Settings = {
    fade: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    afterChange: onSlideChange,
    pauseOnHover: false,
  }

  return (
    <>
      <Link href={href} passHref>
        <a
          id={id}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="thumbnail-floating-banner"
        >
          <div
            css={css`
              position: fixed;
              right: 24px;
              bottom: 24px;
              width: 280px;
              border-radius: 8px;
              overflow: hidden;
              z-index: 20;
              background-color: ${colors.white00};
              box-shadow: 0px 4px 24px rgb(0 0 0 / 12%);
              transition: all 0.4s ease 0s;
              &:hover {
                box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.16);
              }
              ${mq.untilMedium} {
                display: none;
              }
            `}
          >
            <div
              css={css`
                width: 280px;
              `}
            >
              <Slider {...settings}>
                {bannerItems.map((b, i) => (
                  <img
                    key={i}
                    src={b.articleBannerImageUrl}
                    css={css`
                      vertical-align: bottom;
                    `}
                  />
                ))}
              </Slider>
            </div>
            <div
              css={css`
                padding: 8px 0;
                width: 280px;
                background-color: ${colors.white00};
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                line-height: 125%;
                letter-spacing: 0.02em;
                color: ${colors.black10};
              `}
            >
              <div
                css={css`
                  font-size: 11px;
                `}
                data-testid="sub-caption"
              >
                スタートアップ投資・協業の情報収集に
              </div>
              <div
                css={css`
                  font-weight: ${font.weight.bold};
                  font-size: 18px;
                `}
                data-testid="main-caption"
              >
                お役立ち情報をチェック
              </div>
            </div>
          </div>
        </a>
      </Link>
      <div
        data-testid="thumbnail-floating-banner-close"
        css={css`
          position: fixed;
          height: 28px;
          width: 28px;
          right: 16px;
          bottom: 204px;
          z-index: 21;
          background-color: ${colors.black10};
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: background-color 0.2s ease;
          cursor: pointer;
          &:hover {
            background-color: ${colors.black30};
            transition: background-color 0.2s ease;
          }
          ${mq.untilMedium} {
            display: none;
          }
        `}
        onClick={props.onClose}
      >
        <CrossIcon />
      </div>
    </>
  )
}
